<script lang="ts" setup>
// @ts-ignore
import { TrackerDataType } from '@scr-npm/nuxt-tracker/dist/runtime/types'

export type ProductLink = {
    link: string
    text: string
    isExternal?: boolean
}

export interface ProductsItemProps {
    item: ProductBox
    headingLevel: string
    padding?: string
    headingSize?: string
    textSize?: string
}
const props = withDefaults(defineProps<ProductsItemProps>(), {
    padding: 'p-3 p-lg-6',
    headingSize: 'delta',
    textSize: 'fs-normal',
})
const productBoxArticle = ref<HTMLElement>()

const productLink = computed<VNuxtLinkTo>(
    (): VNuxtLinkTo => useProductLink(props.item.cta.primary.link)
)

const { data, sendEvent } = useTracker()

const observer = useObserver()

onMounted((): void => {
    observer(productBoxArticle.value as HTMLElement, (isIntersecting: boolean) => {
        if(isIntersecting) {
            sendEvent({
                data: {
                    ...data,
                    offer_name: props.item.title || '',
                    event: 'insurance_offer_impression',
                }
            })
        }
    })
})
</script>

<template>
  <article
    ref="productBoxArticle"
    :class="[
      'rounded d-flex flex-column justify-content-between bg-white',
      props.padding,
    ]"
  >
    <Tracker :data="{ title: props.item.title } as TrackerDataType">
      <div>
        <div
          v-if="props.item?.tag.length > 0"
          class="d-flex gap-2 mb-2"
        >
          <Label
            v-for="(tag, index) in props.item?.tag"
            :key="index"
            :label="tag.name"
            :text-color="tag.color"
            :background-color="tag.background"
          />
        </div>
        <heading
          :level="props.headingLevel"
          :class="['mb-2 mb-md-3', props.headingSize]"
        >
          {{ props.item.title }}
        </heading>
        <Typo>
          <p class="mb-4">
            {{ props.item.perex }}
          </p>
        </Typo>
      </div>
      <div
        v-if="
          props.item.cta.primary.link || props.item.cta.secondary.link
        "
        class="row g-2"
      >
        <div
          v-if="props.item.cta.primary.link"
          class="col-12 col-lg-auto"
        >
          <VButton
            :to="{
              name: 'insurance-detail',
              params: {
                category: productLink.categoryId,
                id: productLink.productId,
              },
            }"
            :target="
              props.item.cta.primary.isExternal
                ? '_blank'
                : '_self'
            "
            :label="props.item.cta.primary.text"
            size="small"
            class="w-100"
            color="primary"
            classes="align-items-center fw-normal"
          >
            <span class="visually-hidden">{{ $t('Poistenie') }}: {{ props.item.title }}, </span>
            {{ props.item.cta.primary.text }}
          </VButton>
        </div>
        <div
          v-if="props.item.cta.secondary.link"
          class="col-12 col-lg-auto"
        >
          <VButton
            :to="props.item.cta.secondary.link"
            :target="
              props.item.cta.secondary.isExternal
                ? '_blank'
                : '_self'
            "
            :label="props.item.cta.secondary.text"
            size="small"
            class="fs-small col-12 col-lg-auto"
            color="secondary"
            classes="align-items-center fw-normal"
          >
            <span class="visually-hidden">{{ $t('Poistenie') }}: {{ props.item.title }}, </span>
            {{ props.item.cta.secondary.text }}
          </VButton>
        </div>
      </div>
    </Tracker>
  </article>
</template>
